import { useTranslation } from 'react-i18next';
import { Url } from './Url';

export const MapRedirect = ({ item, isCard, isCompany = false, isTopCard }) => {
    const { t } = useTranslation();

    const city = isCompany ? item?.cityCompany : item?.city;
    const address = isCompany ? item?.addressCompany : item?.address;

    if (!city) return null;

    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(city)}`;
    const urlService = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(city)}+${encodeURIComponent(address || '')}`;
    const urlServiceText = address ? `${t(city)}, ${t(address)}` : t(city);
    const urlServiceCard = address ? `${t(city)}` : t(city);

    const style = {
        paddingLeft: !isCard ? 0 : '0.2rem',
    };

    return address ? (
        <Url
            style={style}
            to={urlService}
            text={isTopCard ? urlServiceCard : urlServiceText}
            target="_blank"
        />
    ) : (
        <Url style={style} to={url} text={t(city)} target="_blank" />
    );
};
